// temporary component to add class modifier on player-column element on watch page

import "mutationobserver-shim";

export default class WatchPlayerContainer {
  init() {
    const player = document.querySelector("#article-player")
    const sidebar = document.querySelector(".sidebar-column")

    if(player == null || sidebar == null) {
      return;
    }

    const callback = (mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === "attributes") {
          if(player.classList.contains('cinema-mode')) {
            sidebar.classList.add('player-cinema-mode');
          } else {
            sidebar.classList.remove('player-cinema-mode');
          }
        }
      }
    };

    const configWrapper = { attributes: true };

    this.wrapperObserver = new MutationObserver(callback);
    this.wrapperObserver.observe(
      player,
      configWrapper
    );
  }
}
